export const getBASEBALLLogoURL = (srTeamId: string): string => {
  const baseUrl =
    'https://firebasestorage.googleapis.com/v0/b/data-tech-bb3f7.appspot.com/o/baseball';
  return `${baseUrl}${encodeURIComponent(`/logos/${srTeamId}.png`)}?alt=media`;
};
